export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },
  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },
  adminBlogs: {
    blogList: "api/aiblogs",
    blogCreate: "api/aiblog/store",
    blogEdit: "api/aiblog/edit/",
    blogUpdate: "api/aiblog/update/",
    blogDelete: "api/aiblog/delete",
  },
  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },


  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },
  schemaManagement: {
    view: "api/schema-management",
    update: "api/schema-management/update",
  },
  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },
  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },
  robots: {
    view: "api/robots-txt",
    update: "api/robots-txt/update",
  },
  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },
  contact: {
    contactCreate: "api/contact/store",
    contactList: "api/contact/view",
    contactPageQueryList:"api/contact/view/contact_us",
    broucherPageQueryList:"api/contact/view/download_brouchure_form",
    corporateQueryList: "api/contact/view/corporate_query",
  },
  homeform: {
    homeformCreate: "api/homeform/store",
    homeformList: "api/homeform/view",
  },




  dashboard: {
    dashboardcount: "api/dashboard-counts",
    monthlycount: "api/dashboard-counts/",
  },

  clientLogo: {
    List: "api/logos",
    Create: "api/logo/store",
    Edit: "api/logo/edit/",
    Update: "api/logo/update",
    Delete: "api/logo/delete",
  },

  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },

  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users", userCreate: "api/rbac/user/store", userEdit: "api/rbac/user/edit/", userUpdate: "api/rbac/user/update/", userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles", roleCreate: "api/rbac/role/store", roleEdit: "api/rbac/role/edit/", roleUpdate: "api/rbac/role/update/", roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions", permissionCreate: "api/rbac/permission/store", permissionEdit: "api/rbac/permission/edit/", permissionUpdate: "api/rbac/permission/update/", permissionDelete: "api/rbac/permission/delete",
  },

  galleryCategory: {
    list: "api/gallery-categories",
    create: "api/gallery-category/store",
    edit: "api/gallery-category/edit/",
    update: "api/gallery-category/update/",
    delete: "api/gallery-category/delete",
  },

  gallery: {
    list: "api/galleries",
    create: "api/gallery/store",
    edit: "api/gallery/edit/",
    update: "api/gallery/update/",
    delete: "api/gallery/delete",
    byCategory: "api/gallery/category/",
  },



  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },


  dynamic: {
    dynamicList: "api/service/view",
    dynamicCreate: "api/service/store",
    dynamicEdit: "api/service/edit/",
    dynamicUpdate: "api/service/update/",
    dynamicDelete: "api/service/delete",
  },


};
